export const TKeyAdmin = {
  ADMIN_USERS: "ADMIN_USERS",
  ADMIN_USERS_SEARCH: "ADMIN_USERS_SEARCH",
  ADMIN_USERS_EMPTY: "ADMIN_USERS_EMPTY",
  ADMIN_USERS_COLUMN_USER: "ADMIN_USERS_COLUMN_USER",
  ADMIN_USERS_COLUMN_ROLE: "ADMIN_USERS_COLUMN_ROLE",
  ADMIN_USERS_COLUMN_CREDITS: "ADMIN_USERS_COLUMN_CREDITS",
  ADMIN_USERS_COLUMN_SIGNED_UP: "ADMIN_USERS_COLUMN_SIGNED_UP",
  ADMIN_USER_UNVERIFIED: "ADMIN_USER_UNVERIFIED",
  ADMIN_USER_DELETE_REQUESTED: "ADMIN_USER_DELETE_REQUESTED",
  ADMIN_USER_PROJECTS: "ADMIN_USER_PROJECTS",
  ADMIN_USER_JOBS: "ADMIN_USER_JOBS",
  ADMIN_USER_EXTENSION: "ADMIN_USER_EXTENSION",
  ADMIN_USER_MCP_CALLS: "ADMIN_USER_MCP_CALLS",
  ADMIN_USER_REFERRED_BY: "ADMIN_USER_REFERRED_BY",
  ADMIN_USER_COMPANIES: "ADMIN_USER_COMPANIES",
  ADMIN_USER_ROLE_LABEL: "ADMIN_USER_ROLE_LABEL",
  ADMIN_USER_ROLE_SAVE: "ADMIN_USER_ROLE_SAVE",
  ADMIN_USER_ROLE_UPDATED: "ADMIN_USER_ROLE_UPDATED",
  ADMIN_USER_ADD_CREDITS: "ADMIN_USER_ADD_CREDITS",
  ADMIN_USER_PLAN_LABEL: "ADMIN_USER_PLAN_LABEL",
  ADMIN_USER_PLAN_HINT: "ADMIN_USER_PLAN_HINT",
  ADMIN_USER_PLAN_PRICE: "ADMIN_USER_PLAN_PRICE",
  ADMIN_USER_PLAN_CALL_HOURS: "ADMIN_USER_PLAN_CALL_HOURS",
  ADMIN_USER_PLAN_PROSPECTS: "ADMIN_USER_PLAN_PROSPECTS",
  ADMIN_USER_PLAN_SAVE: "ADMIN_USER_PLAN_SAVE",
  ADMIN_USER_PLAN_UPDATED: "ADMIN_USER_PLAN_UPDATED",
  ADMIN_USER_ADD_CREDITS_LABEL: "ADMIN_USER_ADD_CREDITS_LABEL",
  ADMIN_USER_CREDITS_ADDED: "ADMIN_USER_CREDITS_ADDED",
  ADMIN_PLAN_INTRO: "ADMIN_PLAN_INTRO",
  ADMIN_PLAN_SUMMARY: "ADMIN_PLAN_SUMMARY",
  ADMIN_COSTS: "ADMIN_COSTS",
  ADMIN_COSTS_PERIOD_7: "ADMIN_COSTS_PERIOD_7",
  ADMIN_COSTS_PERIOD_30: "ADMIN_COSTS_PERIOD_30",
  ADMIN_COSTS_PERIOD_90: "ADMIN_COSTS_PERIOD_90",
  ADMIN_COSTS_PERIOD_ALL: "ADMIN_COSTS_PERIOD_ALL",
  ADMIN_COSTS_EMPTY: "ADMIN_COSTS_EMPTY",
  ADMIN_COSTS_COLUMN_ACTION: "ADMIN_COSTS_COLUMN_ACTION",
  ADMIN_COSTS_COLUMN_JOBS: "ADMIN_COSTS_COLUMN_JOBS",
  ADMIN_COSTS_COLUMN_CALLS: "ADMIN_COSTS_COLUMN_CALLS",
  ADMIN_COSTS_COLUMN_COST: "ADMIN_COSTS_COLUMN_COST",
  ADMIN_COSTS_COLUMN_REVENUE: "ADMIN_COSTS_COLUMN_REVENUE",
  ADMIN_COSTS_CASH_HINT: "ADMIN_COSTS_CASH_HINT",
  ADMIN_COSTS_CASH_PURCHASED: "ADMIN_COSTS_CASH_PURCHASED",
  ADMIN_COSTS_CASH_FREE: "ADMIN_COSTS_CASH_FREE",
  ADMIN_COSTS_CASH_IN: "ADMIN_COSTS_CASH_IN",
  ADMIN_COSTS_CASH_MARGIN: "ADMIN_COSTS_CASH_MARGIN",
  ADMIN_COSTS_COLUMN_MARGIN: "ADMIN_COSTS_COLUMN_MARGIN",
  ADMIN_COSTS_TOTAL: "ADMIN_COSTS_TOTAL",
  ADMIN_COSTS_ACTION_CALL_ANALYSIS: "ADMIN_COSTS_ACTION_CALL_ANALYSIS",
  ADMIN_COSTS_ACTION_CLIENT_AVATAR: "ADMIN_COSTS_ACTION_CLIENT_AVATAR",
  ADMIN_COSTS_ACTION_PROSPECT_SEARCH: "ADMIN_COSTS_ACTION_PROSPECT_SEARCH",
  ADMIN_COSTS_ACTION_IMPORTED_PROFILE_DETECTION: "ADMIN_COSTS_ACTION_IMPORTED_PROFILE_DETECTION",
  ADMIN_COSTS_ACTION_MESSAGE_SEQUENCE: "ADMIN_COSTS_ACTION_MESSAGE_SEQUENCE",
  ADMIN_COSTS_ACTION_MESSAGE_SEQUENCE_STEP: "ADMIN_COSTS_ACTION_MESSAGE_SEQUENCE_STEP",
  ADMIN_COSTS_ACTION_REPLY_SUGGESTION: "ADMIN_COSTS_ACTION_REPLY_SUGGESTION",
  ADMIN_COSTS_ACTION_CALL_INSIGHT_RECOUNT: "ADMIN_COSTS_ACTION_CALL_INSIGHT_RECOUNT",
  ADMIN_COSTS_UNBILLED: "ADMIN_COSTS_UNBILLED",
  ADMIN_COSTS_NOT_BILLED: "ADMIN_COSTS_NOT_BILLED",
} as const;
